import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Helpers } from "../helper/helper";
import { BaseService } from "./base.service";
import { TranslateService } from "src/app/services/translate.service";
import { CarDetails } from "../models/carModel";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class VehicleService extends BaseService {
  constructor(
    helper: Helpers,
    private http: HttpClient,
    translate: TranslateService
  ) {
    super(helper, translate);
  }

  addCar(body: any): Observable<any> {
    return this.http
      .post(this.pathAPI + "Vehicle/AddCar", body, super.header())
      .pipe(catchError(super.handleError));
  }

  getCars(): Observable<any> {
    return this.http
      .get(this.pathAPI + "Vehicle/GetCars", super.header())
      .pipe(catchError(super.handleError));
  }

  editCar(id: string, body: any): Observable<any> {
    return this.http
      .put(
        environment.apiUrlForRateCard + "ComprehensiveVehicle/EditCar/" + id,
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  getCarById(id: string): Observable<CarDetails> {
    return this.http
      .get<CarDetails>(
        environment.apiUrlForRateCard + "ComprehensiveVehicle/GetCar/" + id,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  getIDVValue(body: any): Observable<any> {
    return this.http
      .post(this.pathAPI + "Vehicle/IDVValue", body, super.header())
      .pipe(catchError(super.handleError));
  }

  getSummaryByVehicleId(vehicleId: string): Observable<any> {
    return this.http
      .get(this.pathAPI + "Vehicle/Summary/" + vehicleId, super.header())
      .pipe(catchError(super.handleError));
  }

  addEmailOrAddress(body: any, carId: string): Observable<any> {
    return this.http
      .post(
        this.pathAPI + "Vehicle/Confirmation/" + carId,
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  getAllOrders(): Observable<any> {
    return this.http
      .get(this.pathAPI + "Vehicle/AllOrders", super.header())
      .pipe(catchError(super.handleError));
  }

  getVehicleHelp(body: any): Observable<any> {
    return this.http
      .post(this.pathAPI + "Vehicle/Help", body, super.header())
      .pipe(catchError(super.handleError));
  }

  triggerQuoteSubmittedMessage(vehicleId: string): Observable<any> {
    return this.http
      .post(
        environment.apiUrlForRateCard +
          "ComprehensiveVehicle/TriggerRevisitLinkNotification/" +
          vehicleId,
        {},
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  triggerUploadVehicleImageLinkNotification(
    renewComprehensiveCustomerId: string,
    link: string
  ): Observable<any> {
    return this.http
      .post(
        environment.apiUrlForRateCard +
          "ComprehensiveVehicle/TriggerUploadVehicleImageLinkNotification/" +
          renewComprehensiveCustomerId,
        { link },
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  triggerUploadVehicleImageLinkNotificationWithoutId(
    body: TriggerUploadVehicleImageLinkNotificationBody
  ): Observable<any> {
    return this.http
      .post(
        environment.apiUrlForRateCard +
          "ComprehensiveVehicle/TriggerUploadVehicleImageLinkNotification",
        body,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  fetchTemporaryCarDetails(carDetails: CarDetails): Observable<any> {
    let url =
      environment.apiUrlForRateCard +
      "agency/temporary-comprehensive-customer?" +
      "email=" +
      carDetails.owner?.email +
      "&phoneNumber=" +
      carDetails.owner?.phoneNumber +
      "&plateNumber=" +
      carDetails.plateNumber;
    if (carDetails.agencyId) {
      url += "&agencyId=" + carDetails.agencyId;
    }
    if (carDetails.agencyUserId) {
      url += "&agencyUserId=" + carDetails.agencyUserId;
    }
    return this.http
      .get<any>(url, super.header())
      .pipe(catchError(super.handleError));
  }

  registerTemporaryCarDetails(carDetails: CarDetails): Observable<any> {
    return this.http
      .post<any>(
        environment.apiUrlForRateCard +
          "agency/temporary-comprehensive-customer",
        carDetails,
        super.header()
      )
      .pipe(catchError(super.handleError));
  }
}

interface TriggerUploadVehicleImageLinkNotificationBody {
  link: string;
  phoneNumber: string;
  email: string;
}
